import React from 'react'

import { Radio } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { RecipeCustomisationOption } from '@library/api-menu-experience/src/interfaces/recipe'

import { RecipeOptionsItemContent } from './RecipeOptionsItemContent'

import css from './RecipeOptionsItem.css'

type RecipeOptionsItemProps = {
  customisationOption: RecipeCustomisationOption
  isChecked: boolean
  onChange: () => void
}

export const RecipeOptionsItem = ({
  customisationOption,
  isChecked,
  onChange,
}: RecipeOptionsItemProps) => {
  const { recipeId, name, isAvailable, surcharge } = customisationOption

  return (
    <li className={classnames(css.listItem, { [css.listItemChecked]: isChecked })}>
      <Radio
        id={recipeId}
        value={recipeId}
        name="variantList"
        onChange={onChange}
        checked={isChecked}
        style={{ width: '100%' }}
        disabled={!isAvailable}
      >
        {() => (
          <RecipeOptionsItemContent
            recipeName={name}
            pricing={surcharge}
            isOutOfStock={!isAvailable}
            isChecked={isChecked}
          />
        )}
      </Radio>
    </li>
  )
}
